export default __webpack_public_path__ + "static/media/pessoa-fisica.073df512.svg";